import React, { useState } from "react";
import { Colors } from "../Constants/colors";
import { Typography } from "@mui/material";

export interface DropdownOptions {
  /*   key: string; */
  value: string | number | null;
  text: string;
  category?: string;
  metaData?: object;
}
interface Props {
  showDropdown: boolean;
  onSelect: (value: any) => unknown;
  dropdownOption: Array<DropdownOptions>;
  selectedOption?: DropdownOptions;
}

const DropDownOptions = ({
  showDropdown,
  onSelect,
  dropdownOption,
  selectedOption,
}: Props) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  if (!showDropdown) return <></>;

  return (
    <div
      className="flex flex-col p-1 gap-y-1 rounded-md"
      style={{
        position: "absolute",
        zIndex: 999,
        marginTop: "55px",
        width: "100%",
        border: `1px solid ${Colors.LightAshRose} `,
        backgroundColor: `${Colors.White}`,
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        cursor: "pointer",
      }}
    >
      {dropdownOption.map((option, index) => (
        <div
          className="w-full py-3 px-1 rounded-sm"
          style={{
            borderBottom: `${
              index !== dropdownOption.length - 1
                ? `1px solid ${Colors.VeryLightGrey}`
                : ""
            }`,
            backgroundColor:
              hoveredIndex === index ? Colors.VeryLightGrey : "transparent",
          }}
          onClick={() => {
            onSelect(option);
          }}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <Typography color={Colors.AshRose}>{option.text}</Typography>
        </div>
      ))}
    </div>
  );
};

export default DropDownOptions;
